import '@hotwired/turbo-rails'
import '../controllers'
import { initFlowbite } from 'flowbite'

document.addEventListener('turbo:load', initFlowbite)
document.addEventListener('turbo:frame-load', initFlowbite)
document.addEventListener('turbo:after-stream-render', initFlowbite)

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
